import React, { useState } from 'react';
import { Button, Popup } from 'semantic-ui-react';

const ScenarioFieldCell = ({ field, t, changeSettings, extType, isDisabled, fieldName }) => {
    let [open, setOpen] = useState(false);

    const toggle = () => setOpen(prevState => !prevState);

    return (
        <>
            <div className="cell-field-name">{t(fieldName)}</div>
            <Popup
                trigger={
                    <Button
                        size="mini"
                        disabled={isDisabled}
                        className="margin-left-8"
                        onClick={toggle}
                    >
                        {t('All')}
                    </Button>
                }
                content={
                    <Button.Group>
                        <Button
                            size="mini"
                            onClick={() => {
                                changeSettings(field, false, null, extType);
                                toggle();
                            }}
                        >
                            {t('Disable')}
                        </Button>
                        <Button
                            size="mini"
                            onClick={() => {
                                changeSettings(field, true, null, extType);
                                toggle();
                            }}
                        >
                            {t('Enable')}
                        </Button>
                    </Button.Group>
                }
                open={open}
                on="click"
                hideOnScroll
                position="top left"
            />
        </>
    );
};

export default React.memo(ScenarioFieldCell);